export const useElementResize = (
  target: Ref<HTMLElement | null>,
  onResize: () => void,
): void => {
  let observer: ResizeObserver | null = null;

  onMounted(() => {
    observer = new ResizeObserver(onResize);

    watch(
      target,
      (el, _prev, onCleanup) => {
        if (!el) return;
        observer?.observe(el);
        onCleanup(() => observer?.unobserve(el));
      },
      { immediate: true },
    );
  });

  onBeforeUnmount(() => {
    observer?.disconnect();
    observer = null;
  });
};

export default useElementResize;
